<template>
  <div>
    <a-divider />
    <div class="row">
      <div class="col">
        <h5 class="mb-0">Internal Assessment Mark</h5>
        <p class="mb-3 text-primary">Select the Internal to add marks for and click on the Subject to start adding the respective internal marks.</p>
      </div>
    </div>
    <a-divider />

    <template v-if="settingsExists">
      <div class="neo-tabs-internal">
        <a-tabs @change="handleInternalChange" size="small">
          <a-tab-pane
            v-for="internal in internalAssessmentsSetting"
            :tab="internal.internal_assessment.name"
            :key="internal.internal_a_id"
          >
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead>
                  <tr class="bg-light">
                    <th>Student Code (Roll)</th>
                    <th
                      class="neo-exam-marks-subjects-cell"
                      v-for="examSubject in examSubjects"
                      :key="examSubject.subject_id"
                      @click="openMarksFormModal(internalData, examSubject, internal)"
                    >
                      {{examSubject.subject.abbreviation}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="enrollment in internalData" :key="enrollment.id">
                    <th style="min-width:30px; vertical-align:middle;" class="text-left">
                      {{enrollment.student_code}}({{enrollment.roll_no}})
                    </th>
                    <td style="min-width:50px;" v-for="examSubject in examSubjects" :key="examSubject.subject_id">
                      {{ getInternalMark(enrollment.final_internal_assessment_mark, examSubject.subject_id, internal.internal_a_id) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </template>
    <template v-else>
      <p class="mb-0 py-3 text-danger">No Final Result Setting found for this class! You need to setup Final Results Settings before you can manage internal marks!</p>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import { find } from 'lodash'

export default {
  name: 'InternalMarksList',
  props: {
    settingData: Object,
    sectionId: Number,
    session: Number,
    classId: Number,
    internalData: Array,
  },
  components: {
  },
  mounted: function() {
    // console.log(this.sectionId, this.session, this.classId)
    // this.getInitialData()
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      selectedInternal: null,
    }
  },
  computed: {
    settingsExists: function() {
      if (this.settingData.final_results_settings.length !== 0) {
        return true
      } else {
        return false
      }
    },
    selectedSection: function() {
      return this.sectionId
    },
    internalAssessmentsSetting: function() {
      const setting = find(this.settingData.final_results_settings, { is_unique: 0 })
      if (setting) {
        return setting.final_internal_assessment_settings
      } else {
        return []
      }
    },
    examSubjects: function() {
      const setting = find(this.settingData.final_results_settings, { is_unique: 0 })
      if (setting) {
        return setting.final_exam_subjects
      } else {
        return []
      }
    },
    examDeclared: function() {
      const setting = find(this.settingData.final_results_settings, { is_unique: 0 })
      if (setting) {
        return setting.is_declared === 1
      } else {
        return false
      }
    },
  },
  methods: {
    moment,
    handleInternalChange(internalId) {
      this.selectedInternal = internalId
    },
    getInternalMark(data, subjectId, internalId) {
      const internalMark = find(data, {
        subject_id: subjectId,
        internal_assessment_id: internalId,
      })

      if (internalMark) {
        return internalMark.final_student_internal_assessment_mark
      } else {
        return '-'
      }
    },
    openMarksFormModal: function(internalData, examSubject, internal) {
      if (!this.examDeclared) {
        this.$eventBus.$emit('openInternalMarksForm', internalData, examSubject, internal, this.classId, this.sectionId)
      } else {
        this.$info({
          title: 'Final results already declared',
          content: 'You cannot add or edit marks as the finals for this class has already been declared!',
          onOk() {},
        })
      }
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to save?`,
            content: `Click on the OK button to save final result settings!`,
            onOk: () => {
              const formData = this.makeFormData(values)
              this.$http
                .post('/api/finalresultsetting', formData)
                .then(({ data }) => {
                  this.$emit('saved')
                  this.loading = false
                  this.$notification['success']({
                    message: 'Saved successfully',
                    description: `Final result settings saved successfully!`,
                  })
                  // this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },

    makeFormData(values) {
      // make subjects
      const subjects = values.final_exam_subjects.filter(element => {
        return element.selected
      }).map(element => {
        delete element['selected']
        element.grades_only = element.grades_only ? 1 : 0
        element.is_in_total = element.is_in_total ? 1 : 0
        return element
      })

      // make internal assessments
      const internalAssessments = values.internal_assessment_subject_weightage.filter(element => {
        return element.selected
      }).map(element => {
        delete element['selected']
        return element
      })

      // make exams
      if (!this.examResultAsFinal) {
        const exams = values.exam_weightages.filter(element => {
          return element.selected
        }).map(element => {
          delete element['selected']
          return element
        })

        values.exam_weightages = exams
      }

      values.class_id = this.classId
      values.exam_result_as_final = this.examResultAsFinal ? 1 : 0
      values.sections = this.classSections

      values.session_id = this.session
      values.final_exam_subjects = subjects
      values.internal_assessment_subject_weightage = internalAssessments

      return values
    },
  },
}
</script>
